import { ComponentType, FC, useEffect } from 'react';
import styled from '@emotion/styled';
import * as Sentry from '@sentry/nextjs';
import { useTranslation } from 'next-i18next';
import CloseButtonBase from 'src/components/Event/common/CloseButton';
import { safeWindow } from 'src/utils/static-generation';
const FloatingCloseButton = styled(CloseButtonBase)`
  position: fixed;
  top: 8px;
  left: 8px;
`;
const ErrorScreenWrap = styled.div`
  width: 100%;
  height: var(--100vh);
  padding: 32px;
  background-color: ${({
  theme
}) => theme.color.surfaceDeepFixed};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;
const ErrorImage = styled.img`
  width: 100px;
  height: 100px;
`;
const ErrorText = styled.span`
  font-size: 14px;
  line-height: 17px;
  color: ${({
  theme
}) => theme.color.content9};
`;

/**
 * 웹클라이언트 전용 페이지에서 적용하는 HOC
 * 웹뷰 환경에서 접속 시도 시 로깅과 함께 에러 UI 노출
 */
function withWebClientValidation<Props extends object>(WrappedComponent: ComponentType<Props>) {
  const WithWebClientValidation: FC<Props> = props => {
    const {
      t
    } = useTranslation();
    useEffect(() => {
      if (window.AzarJs) {
        Sentry.captureMessage('Attempted to access web client dedicated page in webview', {
          extra: {
            pathname: window.location.pathname,
            apiVersion: window.AzarJs.getApiVersion?.()
          }
        });
      }
    }, []);
    if (safeWindow?.AzarJs) {
      return <>
          <ErrorScreenWrap>
            <FloatingCloseButton />
            <ErrorImage src='/images/icons/imgPlaceholder.svg' alt='error' />
            <ErrorText>{t('ERROR_PROBLEM')}</ErrorText>
          </ErrorScreenWrap>
        </>;
    }
    return <WrappedComponent {...props} data-sentry-element="WrappedComponent" data-sentry-component="WithWebClientValidation" data-sentry-source-file="withWebClientValidation.tsx" />;
  };
  return WithWebClientValidation;
}
export default withWebClientValidation;